import { defaultDeploymentTravelWillingnessData } from '../../../../backend/config/classifiers/defaults/DefaultDeploymentTravelWillingnessData';
import { deploymentTravelWillingnessSchema } from '../../../../backend/config/classifiers/types';
import { allowManageCredentialingClassifiers } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const deploymentTravelWillingnessEntityName = 'deploymentTravelWillingness';
const deploymentTravelWillingnessColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { displayOrder: {
        type: 'number',
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineDeploymentTravelWillingnessClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 3,
            columns: deploymentTravelWillingnessColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { displayOrder: params.data.displayOrder, search: [params.data.name, params.data.status, params.data.displayOrder].join(' ') });
            },
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: defaultDeploymentTravelWillingnessData,
        publicData: [
            {
                displayOrder: true,
            },
        ],
    }, deploymentTravelWillingnessSchema);
}
